import React, { useState } from "react";
import { Col, Row, Card, Form, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown, faCheckCircle, faTimesCircle, faPlus } from '@fortawesome/free-solid-svg-icons';

export default () => {
  const [formData, setFormData] = useState({
    fakeAccountSelect: "",
    storyType: "Metin",
    storyText: "",
    backgroundColor: "",
    duration: 24,
    durationUnit: "Saat",
    vipStory: false,
    activeStory: true,
    autoDelete: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form data:", formData);
  };

  return (
    <>
      <div className="py-4">
        <h4>Ekle</h4>
        <p className="text-muted mb-0">Hikayeler / Ekle</p>
      </div>

      <Card className="border-0 shadow-sm mb-4">
        <Card.Body>
          <h5 className="mb-3">Fake Kullanıcı Seçimi</h5>
          <p className="text-muted small">Hikaye eklemek için kullanıcı seçin</p>

          <Form onSubmit={handleSubmit}>
            <Row className="mb-4">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>
                    Hesap Seçin <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="fakeAccountSelect"
                    value={formData.fakeAccountSelect}
                    onChange={(e) => setFormData(prev => ({ ...prev, fakeAccountSelect: e.target.value }))}
                    required
                  >
                    <option value="">Seçiniz...</option>
                    <option value="account1">Fake Hesap 1</option>
                    <option value="account2">Fake Hesap 2</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <h5 className="mb-3 mt-4">Hikaye Oluştur</h5>
            <p className="text-muted small">Yeni bir hikaye ekleyin</p>

            <Row className="mb-3">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>
                    Hikaye Türü <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="storyType"
                    value={formData.storyType}
                    onChange={(e) => setFormData(prev => ({ ...prev, storyType: e.target.value }))}
                    required
                  >
                    <option value="Metin">Metin</option>
                    <option value="Resim">Resim</option>
                    <option value="Video">Video</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>
                    Hikaye Metni <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="storyText"
                    placeholder="Hikaye metninizi yazın..."
                    value={formData.storyText}
                    onChange={(e) => setFormData(prev => ({ ...prev, storyText: e.target.value }))}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>Arkaplan Rengi</Form.Label>
                  <div className="d-flex align-items-center gap-2">
                    <Form.Control
                      type="color"
                      name="backgroundColor"
                      value={formData.backgroundColor}
                      onChange={(e) => setFormData(prev => ({ ...prev, backgroundColor: e.target.value }))}
                      style={{ width: '60px', height: '40px' }}
                    />
                    <Button variant="light" size="sm">
                      <FontAwesomeIcon icon={faTimesCircle} className="text-muted" />
                    </Button>
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>
                    Süre <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="duration"
                    value={formData.duration}
                    onChange={(e) => setFormData(prev => ({ ...prev, duration: e.target.value }))}
                    min="1"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>
                    Süre Birimi <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    name="durationUnit"
                    value={formData.durationUnit}
                    onChange={(e) => setFormData(prev => ({ ...prev, durationUnit: e.target.value }))}
                    required
                  >
                    <option value="Saat">Saat</option>
                    <option value="Gün">Gün</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <h5 className="mb-3 mt-4">Hikaye Ayarları</h5>

            <Row className="mb-3">
              <Col md={12}>
                <Card className="border-0 bg-light">
                  <Card.Body className="py-3">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <div className="d-flex align-items-center gap-2">
                        <FontAwesomeIcon icon={faCrown} className="text-warning" />
                        <div>
                          <strong>VIP Hikaye</strong>
                          <p className="mb-0 small text-muted">Sadece VIP üyelere göster</p>
                        </div>
                      </div>
                      <Form.Check
                        type="switch"
                        id="vip-story"
                        checked={formData.vipStory}
                        onChange={(e) => setFormData(prev => ({ ...prev, vipStory: e.target.checked }))}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={12}>
                <Card className="border-0 bg-light">
                  <Card.Body className="py-3">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <div className="d-flex align-items-center gap-2">
                        <FontAwesomeIcon icon={faCheckCircle} className="text-success" />
                        <div>
                          <strong>Aktif</strong>
                          <p className="mb-0 small text-muted">Hikayesi hemen yayınla</p>
                        </div>
                      </div>
                      <Form.Check
                        type="switch"
                        id="active-story"
                        checked={formData.activeStory}
                        onChange={(e) => setFormData(prev => ({ ...prev, activeStory: e.target.checked }))}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={12}>
                <Card className="border-0 bg-light">
                  <Card.Body className="py-3">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <div className="d-flex align-items-center gap-2">
                        <FontAwesomeIcon icon={faTimesCircle} className="text-danger" />
                        <div>
                          <strong>Otomatik Sil</strong>
                          <p className="mb-0 small text-muted">Süre sonunda otomatik sil</p>
                        </div>
                      </div>
                      <Form.Check
                        type="switch"
                        id="auto-delete"
                        checked={formData.autoDelete}
                        onChange={(e) => setFormData(prev => ({ ...prev, autoDelete: e.target.checked }))}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <div className="d-flex justify-content-start">
              <Button variant="primary" type="submit" size="lg">
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Hikaye Oluştur
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};
